<template>
<b-card>
    <b-card-body>
    
        <h4>HR Intake and Assignment</h4>

        <form-summary :validator="$v" ref="errorContainer" id="errorContainer"/>

        <b-form @submit.stop.prevent="onSubmit">
            <b-row>
                <b-col>
                     <BaseSelector v-model="assignedSpecialist" 
                        :v="$v.assignedSpecialist"
                        label="HR Specialist Assignment"
                        :options = specialists
                         />
                </b-col>
                <b-col>
                    <BaseParagraphInput v-model="comments"
                        :v="$v.comments" 
                        label="Comments"
                         tip="Summarize in 1000 characters or less the additional information needed."/>
                </b-col>
            </b-row>
                    <div>
              <b-button type="submit" variant="primary">Submit</b-button>

            </div>
        </b-form>
    </b-card-body>
</b-card>

</template>

<script>
    import axios from "axios"
import { required, email, minLength, maxLength, numeric } from 'vuelidate/lib/validators'

export default {
    components: {
    },
    props: {
        request: Object
    },
    data() {
        return {
            assignedSpecialist: null,
            comments: null,
            specialists: [],         
        }
    },
     validations: {
                    assignedSpecialist: {  },
                    comments: {maxLength: maxLength(4000) }

     },

        computed: {
        
    },
    created() {
        this.fetchSpecialists()
    },
    
    methods: {
        fetchSpecialists() {
            axios.get(`${process.env.VUE_APP_API_BASE_URL}/organization/specialist`)
                .then(response => { 
                    this.specialists = []

                    response.data.forEach((employee) => {
                        let option = {
                            value: employee.userId,
                            text: employee.name
                        }
                        this.specialists.push(option)
                    })
                })
        },
        onSubmit() {
            this.$v.$touch();
            if (this.$v.$invalid) {
                           this.$nextTick(() => {
                document.getElementById('form-container').scrollIntoView()
                          })
                return
            }
            axios.post(`${process.env.VUE_APP_API_BASE_URL}/request/assignment`,
                    {
                        id: this.request.id,
                        userAssignment: this.assignedSpecialist
                    })
                  .then(response => { console.log("back ") })
        }
    }   
}
</script>